module.exports = __webpack_public_path__ + "static/fashion-section-button-cab326525f27f1c970bcf29933bbd959.png";